import { privateClient } from "../../configs/axiosConfig";

const statisticEndpoints = {
  getBookingStats: "v2/statistic/bookingstatistic",
};

const statisticApi = {
  // Get booking statistics, optionally filter by operatorId
  getBookingStats: async (operatorId = null) => {
    try {
      const response = await privateClient.get(
        statisticEndpoints.getBookingStats,
        {
          params: operatorId ? { operatorId } : {},
        }
      );
      return { response };
    } catch (err) {
      console.error("Error fetching booking statistics:", err);
      return { err };
    }
  },
};

export default statisticApi;
